import { axiosReq } from "@/lib/axios"
import { ScheduleFormDataType } from "../components/ScheduleForm"
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const usePostScheduleDemo = () => {

  const request = async (data: ScheduleFormDataType) => {
    const formData = {
    firstName: data.firstName,
    lastName: data.firstName,
    email: data.email,
    company: data.email,
    message: data.message
}
    const response = await axiosReq.post('/api/approval/enquiry/', formData);
    return response.data;
  }

  const { mutate: scheduleDemo, status } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      toast.message("Our Team will get back to you shortly")
    },
    onError: () => {
      toast.message("Our Team will get back to you shortly")
    }

  })

  return { scheduleDemo, status }

}
